import styled from 'styled-components';

export const StyledLogoContainer = styled.div<{
  containerWidth: number;
  containerHeight: number;
  isLink: boolean;
  hoverColor: string;
  color: string;
}>`
  width: ${props => (!props.isLink ? `${props.containerWidth}px` : '100%')};
  height: ${props => (!props.isLink ? `${props.containerHeight}px` : '100%')};
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    width: ${props => props.containerWidth}px;
    height: ${props => props.containerHeight}px;
    display: flex;

    &.bottom-left {
      justify-content: left;
      align-items: end;
    }

    &.center-left {
      justify-content: left;
      align-items: center;
    }

    &.bottom-center {
      justify-content: center;
      align-items: end;
    }

    &.centered {
      justify-content: center;
      align-items: center;
    }
  }

  /* DAC Image styling */
  img {
    &.dac-logo {
      max-width: 100%;
      max-height: 100%;
    }

    &.bottom-left {
      align-self: flex-end;
      justify-self: flex-start;
    }

    &.center-left {
      align-self: center;
      justify-self: flex-start;
    }

    &.bottom-center {
      align-self: flex-end;
      justify-self: center;
    }

    &.centered {
      align-self: center;
      justify-self: center;
    }
  }

  .alternate-logo svg path {
    fill: ${props => props.color !== 'color' && props.color !== 'background-aware' && '#707070'};
  }

  .grey-logo svg path {
    fill: var(--t-logo-grey-color, #707070) !important;
  }

  .background-aware-logo svg path,
  .standard .background-aware-logo svg path,
  .inverse .background-aware-logo svg path,
  .alternate .background-aware-logo svg path,
  [class^='color-scheme'] .background-aware-logo svg path {
    fill: var(--t-logo-fg-color, black) !important;
  }

  .white-logo svg path {
    fill: var(--t-logo-white-color, #ffffff) !important;
  }

  &:hover .alternate-logo svg path,
  &:hover .grey-logo svg path,
  &:hover .background-aware-logo svg path,
  &:hover .standard .background-aware-logo svg path,
  &:hover .inverse .background-aware-logo svg path,
  &:hover .alternate .background-aware-logo svg path,
  &:hover .white-logo svg path,
  &:hover [class^='color-scheme'] .background-aware-logo svg path {
    fill: ${props => props.hoverColor} !important;
  }
`;
